import { render, staticRenderFns } from "./TerminalDetails.vue?vue&type=template&id=196672fc&scoped=true"
import script from "./TerminalDetails.vue?vue&type=script&lang=js"
export * from "./TerminalDetails.vue?vue&type=script&lang=js"
import style0 from "./TerminalDetails.vue?vue&type=style&index=0&id=196672fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196672fc",
  null
  
)

/* custom blocks */
import block0 from "./TerminalDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports